var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view__event_show"},[(_vm.allow)?[_c('event-show')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }